
import { defineComponent } from 'vue'
import { socialMedia } from '@/data/navigation/footer'
import Brands from './Brands.vue'

export default defineComponent({
  data() {
    return {
      socialMedia,
      year: new Date().getFullYear(),
    }
  },
  components: {
    Brands,
  },
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
    privacyPolicyLink(): string {
      return `/privacy-policy`
    },
    termsOfUseLink(): string {
      return `/terms-of-use`
    },
  },
})
